import { render, staticRenderFns } from "./StatusState.vue?vue&type=template&id=b82610f0&scoped=true&"
import script from "./StatusState.vue?vue&type=script&lang=js&"
export * from "./StatusState.vue?vue&type=script&lang=js&"
import style0 from "./StatusState.vue?vue&type=style&index=0&id=b82610f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82610f0",
  null
  
)

export default component.exports